module.exports = __webpack_public_path__ + "media/images/unlocked-617cb481a62719a68b9e6246a858196a.svg";